<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"  background-size: cover;"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"margin-top:50px;"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-section-201 v-bind='{...{"mediaType":"video","image":"https:\/\/api.mixitweb.com\/storage\/videos\/kiosk.mp4","alt":"","controls":true,"videoSrc":"https:\/\/api.mixitweb.com\/storage\/videos\/kiosk.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"height:50vh;\n\n"' class="p-2 py-5" >
                <template #bottom-1>   </template>
                
                <template #bottom-2>   </template>
                
                <template #bottom-3>   </template>
                
                <template #mid-1>   </template>
                
                <template #mid-2>   <m-h1 v-bind='{...{},...{}}' :style='"padding: 5px ;"' class="" >
                <template #default>کیوسک دیجیتال    </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>با استفاده از کیوسک دیجیتال میتوانید تجربه کاربری بهتری جهت سهولت در گرفتن سفارش و نمایش نمونه کار های خود و همچنین گرفتن نوبت از سوی مشتریان خود دریافت کنید   </template>
                </m-p></template>
                
                <template #mid-3>   </template>
                
                <template #top-1>   </template>
                
                <template #top-2>   </template>
                
                <template #top-3>   </template>
                </m-section-201></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>ویژگی ها   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>با میکسیت وب مدرن ترین و کاربردی ترین ویژگی ها را بدست بیاورید    </template>
                </m-p><m-content-slider-4 v-bind='{...{"cardLink":false,"contentCategory":["kiosk-katalog"],"contentType":"page","slicer":null,"itemClass":"col-lg-3 my-2","waitForCategoryProp":false,"categoryColumnProp":"slug","contentCard":"mContentCard316","sliderPagination":true,"swiperPerViewSM":1,"swiperPerViewMD":2,"swiperPerViewLG":4,"swiperPerViewSpaceBetweenSM":30,"swiperPerViewSpaceBetweenMD":30,"swiperPerViewSpaceBetweenLG":30,"sliderGridStatus":false,"sliderGridRows":2,"sliderLoop":false,"contentDirectLinkOn":false},...{}}' :style='""' class="col" ></m-content-slider-4></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   </template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 " >
                <template #default>   <m-video v-bind='{...{"controls":true,"videoSrc":"https:\/\/api.mixitweb.com\/storage\/logos\/video_2024-11-14_11-42-34.mp4","autoplay":false,"muted":false,"loop":false,"poster":null},...{}}' :style='"border-radius:15px;"' class="img-fluid mt-4" ></m-video></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection201 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section201'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mContentSlider4 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider4'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection201,mH1,mP,mContentSlider4,mVideo },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
